import { render, staticRenderFns } from "./SupportsEdit.vue?vue&type=template&id=f9fbbf76&"
import script from "./SupportsEdit.vue?vue&type=script&lang=js&"
export * from "./SupportsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports